import React from 'react';
import type ForgeGlobalPageType from '@atlassian/jira-spa-apps-forge-global/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyForgeGlobalPage = lazyForPaint<typeof ForgeGlobalPageType>(
	() =>
		import(
			/* webpackChunkName: "async-forge-spa-global", jiraSpaEntry: "async-forge-spa-global" */ '@atlassian/jira-spa-apps-forge-global'
		),
);

export const ForgeGlobalPage = () => (
	<LazyPage Page={LazyForgeGlobalPage} pageId="forge-spa-global" shouldShowSpinner />
);

export default ForgeGlobalPage;
